export default __webpack_public_path__ + "static/media/choose_1.5357049a.png";